// Shared display helpers for the My Tasks module (list, work list, detail).

export const PRIORITIES = ["Low", "Medium", "High"];
export const STATUSES = ["Pending", "In Progress", "Complete"];

export const priorityBadge = (priority) => {
  if (priority === "High") return "badge bg-danger";
  if (priority === "Low") return "badge bg-secondary";
  return "badge bg-warning text-dark";
};

export const statusBadge = (status) => {
  if (status === "Complete") return "badge bg-success";
  if (status === "In Progress") return "badge bg-primary";
  return "badge bg-secondary";
};

export const fmtDateTime = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

// A task's date: its due date, or the day it was created when it has none.
// Matches the backend's newest-first sort.
export const taskDate = (task) => {
  const d = new Date(task.dueAt || task.createdAt);
  return Number.isNaN(d.getTime()) ? null : d;
};

// Local YYYY-MM-DD key for grouping tasks by day.
export const dayKey = (d) =>
  d
    ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
    : "none";

// "Today" / "Yesterday" / "Tomorrow" / "Tue, 29 Sep 2026"
export const fmtDayLabel = (d) => {
  if (!d) return "No date";
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const day = new Date(d);
  day.setHours(0, 0, 0, 0);
  const diff = Math.round((day - today) / 86400000);
  if (diff === 0) return "Today";
  if (diff === -1) return "Yesterday";
  if (diff === 1) return "Tomorrow";
  return d.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
